import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/edit.png'
import _imports_1 from '@/assets/image/wash-mark.png'
import _imports_2 from '@/assets/image/wash-ex.png'


const _withScopeId = n => (_pushScopeId("data-v-001b8291"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wash-mark-title" }
const _hoisted_2 = { class: "flex-ter mb_15 pl_35 pr_25" }
const _hoisted_3 = { class: "mr_10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_5 = { class: "wash-tip" }
const _hoisted_6 = { class: "wash-tip-title" }
const _hoisted_7 = { class: "wash-tip-text" }
const _hoisted_8 = { class: "wash-tip-text-main" }
const _hoisted_9 = { class: "wash-tip-text" }
const _hoisted_10 = { class: "wash-tip-text-main" }
const _hoisted_11 = {
  class: "wash-tip-text",
  style: {"padding-bottom":"32px"}
}
const _hoisted_12 = { class: "wash-tip-text-main" }
const _hoisted_13 = { class: "wash-link" }
const _hoisted_14 = { class: "goods-sku" }
const _hoisted_15 = { class: "title rel" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "abs",
  style: {"color":"red","left":"-10px"}
}, "*", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "goods-sku props flex-ter" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"30px"} }, "M", -1))
const _hoisted_22 = { class: "tip" }
const _hoisted_23 = { class: "goods-sku props flex-ter" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_26 = { style: {"margin-left":"30px"} }
const _hoisted_27 = { class: "tip" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-mark-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_29 = { class: "wash-input" }
const _hoisted_30 = {
  class: "wash-input-item",
  style: {"height":"40px"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "wash-input-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "made-china"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-title" }, "Points to Note"),
  /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "wash-tip-text-main" }, " This product is washed independently when washing, will local heavy dirt first, after the whole garment washing, button or zipper clothing first button or zipper button or zipper, immersion time should be short, 2 minutes is preferred. ")
  ])
], -1))
const _hoisted_36 = { class: "wash-link" }
const _hoisted_37 = { class: "goods-sku" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SKU：", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "goods-sku props flex-ter" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SIZE：", -1))
const _hoisted_42 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"30px"} }, "M", -1))
const _hoisted_44 = { class: "tip" }
const _hoisted_45 = { class: "goods-sku props flex-ter" }
const _hoisted_46 = { class: "title" }
const _hoisted_47 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"30px"} }, "cotton100％", -1))
const _hoisted_49 = { class: "tip" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wash-mark-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "made-in" }, " MADE IN CHINA ", -1))
const _hoisted_52 = { class: "wash-right" }
const _hoisted_53 = {
  class: "wash-warn",
  style: {"padding-bottom":"68px"}
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  class: "wash-warn-text",
  style: {"padding-bottom":"56px"}
}
const _hoisted_56 = {
  class: "wash-warn-text",
  style: {"padding-bottom":"198px"}
}
const _hoisted_57 = {
  key: 1,
  class: "wash-warn-text",
  style: {"padding-bottom":"227px"}
}
const _hoisted_58 = {
  class: "wash-warn",
  style: {"padding-bottom":"7px","padding-top":"35px"}
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_60 = { class: "wash-submit flex-bwn mr_20" }
const _hoisted_61 = { class: "ml_35 flex-ter gap-1" }
const _hoisted_62 = { style: {"max-width":"200px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong cursor-pt" }, null, -1))
const _hoisted_64 = { class: "text-rt" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { Close, RefreshRight, QuestionFilled } from '@element-plus/icons-vue'
import { confirmEdit } from '@/util/useConfirm'
import { addWashingMark, getWashingMark, getWashingMarkList, updateWashingMark } from '@/apis/setup'
import { useRequest } from '@/util/useLoading'
import UploadImageLimit from '@/components/common/UploadImageLimit.vue'
import CropperImage from '../additional/components/CropperImage.vue'
import { ElMessage } from 'element-plus'
import { isD2C, isJA, isKO, useSite } from '@/store'
import bus from '@/util/useBus'

export default /*#__PURE__*/_defineComponent({
  props: {
    washData: { type: null, required: true },
    first: { type: null, required: true }
  },
  emits: ['close', 'update'],
  setup(__props: any, { emit }) {

const props = __props as {washData:any, first:any}
const visible = ref(true)
const urlList: any = ref([])
const washMark: any = ref({})
const skuType: any = ref()
const isRotate: any = ref(false)
const imageRatio = ref(0)
const editStatus: any = ref({
  skuType: false,
  companyName: false,
  companyAddress: false
})



const [loading, api] = useRequest((data: any) => {
  return washMark.value.washedlabelAdditionId ? updateWashingMark(data) : addWashingMark(data)
})

const cancel = () => {
  confirmEdit(
    () => (visible.value = false),
    () => { }
  )
}

watch(props.washData, (item = {}) => {
  washMark.value = { ...item }
  urlList.value = item.companyLogo ? [item.companyLogo] : []
  skuType.value = item.productDesignation
  if (item.imageRatio) {
    imageRatio.value = item.imageRatio
  }
  // if (item.model === 1) {
  //   // 竖向
  // } else if (item.model === 2) {
  //   // 横向暂时不用
  // }
  if (props.first) {
    washMark.value.isDefault = 1
  }
  if (!washMark.value.washedlabelName) {
    getWashingMarkList().then(res => {
      if (res.success && res.data.length === 0) {
        washMark.value.washedlabelName = t('默认水洗标')
      }
    })
  }
}, {
  immediate: true
})

const save = (): void => {
  // if (urlList.value.length === 0) {
  //   ElMessage.warning(t('上传店铺品牌logo'))
  //   return
  // }
  if (!washMark.value.washedlabelName) {
    ElMessage.warning(t('请填写水洗标名称'))
    return
  }
  if (!skuType.value) {
    ElMessage.warning(t('请选择商品番号填写方式'))
    return
  }
  // if (!washMark.value.companyName) {
  //   ElMessage.warning(t('请输入会社名'))
  //   return
  // }
  // if (!washMark.value.companyAddress) {
  //   ElMessage.warning(t('请输入会社地址'))
  //   return
  // }
  api({
    ...washMark.value,
    companyLogo: urlList.value?.[0] ?? '',
    model: 1,
    productDesignation: skuType.value,
    imageRatio: imageRatio.value
  }).then((res:any) => {
    if (res.success) {
      ElMessage.success(t('保存成功'))
      cancel()
      emit('update')
      bus.emit('updateWashMark')
    }
  })
}
const changeEditStatus = (key: string): void => {
  editStatus.value[key] = true
}
const closeEdit = (e: any): void => {
  const ele1 = document.querySelector('.selectSku')
  const ele2 = document.querySelector('.selectInput1')
  const ele3 = document.querySelector('.selectInput2')
  const isHave = isChildOf(e.target, ele1) || isChildOf(e.target, ele2) || isChildOf(e.target, ele3)
  if (isHave) {
    return
  }
  editStatus.value = {
    skuType: false,
    companyName: false,
    companyAddress: false
  }
}

// 打开编辑器
const cropperImage = ref()
const openCropperImage = () => {
  console.log(urlList.value)
  cropperImage.value.open(urlList.value[0])
}

const submitCropperImage = (url: any, type: number) => {
  urlList.value = [url]
  imageRatio.value = type
  console.log(type)
}
const changeImage = (url: any) => {
  if (!url) {
    imageRatio.value = 0
    return
  }
  openCropperImage()
}
const isChildOf = (child: any, parent: any) => {
  if (child && parent) {
    let parentNode = child.parentNode
    while (parentNode) {
      if (parent === parentNode) {
        return true
      }
      parentNode = parentNode.parentNode
    }
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": visible.value,
    "show-close": false,
    width: "700px",
    top: "10vh",
    "destroy-on-close": "",
    onClosed: _cache[14] || (_cache[14] = ($event: any) => (emit('close'))),
    "custom-class": "washing-mark-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "wash-mark",
        onClick: closeEdit
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("水洗标信息配置")), 1),
        _createVNode(_component_el_icon, {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["stop"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_unref(t)('水洗标名称')), 1)
          ]),
          _createVNode(_component_el_input, {
            style: {"font-family":"PingFangSC"},
            modelValue: washMark.value.washedlabelName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((washMark.value.washedlabelName) = $event)),
            class: "fx-1",
            placeholder: _unref(t)('请输入水洗标名称'),
            maxlength: 100
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["wash-content", 'wash-content-' + _unref(useSite)()])
        }, [
          (!_unref(isKO)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ 'active': isRotate.value }, 'wash-left'])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('注意事項')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('2.洗濯後多少の縮みがあります。')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "wash-image",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(UploadImageLimit, {
                    limit: 1,
                    urlList: urlList.value,
                    "onUpdate:urlList": _cache[2] || (_cache[2] = ($event: any) => ((urlList).value = $event)),
                    rotate: isRotate.value,
                    onEdit: openCropperImage,
                    imageRatio: imageRatio.value,
                    onChange: changeImage
                  }, null, 8, ["urlList", "rotate", "imageRatio"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ 'active': isRotate.value }, 'text'])
                  }, _toDisplayString(_unref(t)("对折")), 3)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('客户商品sku')) + "： ", 1)
                  ]),
                  (!editStatus.value.skuType)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "placeholder abs",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changeEditStatus('skuType')), ["stop"]))
                      }, [
                        _createTextVNode(_toDisplayString(skuType.value == 1
                  ? _unref(t)("不使用客户商品sku")
                  : skuType.value == 2
                    ? _unref(t)("使用客户商品sku")
                    : skuType.value == 3
                      ? _unref(t)("使用客户商品sku")
                      : _unref(t)("关联商品库填写")) + " ", 1),
                        _hoisted_17
                      ]))
                    : _createCommentVNode("", true),
                  (editStatus.value.skuType)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: skuType.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((skuType).value = $event)),
                        style: {"width":"140px"},
                        class: "selectSku"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _unref(t)('不使用客户商品sku'),
                            value: 1
                          }, null, 8, ["label"]),
                          (_unref(isD2C)())
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 0,
                                label: _unref(t)('使用客户商品sku'),
                                value: 2
                              }, null, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (!_unref(isD2C)())
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                label: _unref(t)('使用客户商品sku'),
                                value: 3
                              }, null, 8, ["label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('規格')) + "：", 1),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('商品的规格，请从选项设定画面进行编辑。未输入的情况下不显示')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        color: "#999",
                        class: "cursor-pt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, " (" + _toDisplayString(_unref(t)("示例")) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('表地：')), 1),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('材质为自动读取，不可编辑')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        color: "#999",
                        class: "cursor-pt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('綿100％')), 1),
                  _createElementVNode("span", _hoisted_27, " (" + _toDisplayString(_unref(t)("示例")) + ") ", 1)
                ]),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (!editStatus.value.companyName)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "placeholder",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (changeEditStatus('companyName')), ["stop"]))
                        }, [
                          _createTextVNode(_toDisplayString(washMark.value.companyName
                    ? washMark.value.companyName
                    : _unref(t)("请填写会社名")) + " ", 1),
                          _hoisted_31
                        ]))
                      : _createCommentVNode("", true),
                    (editStatus.value.companyName)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          placeholder: _unref(t)('请填写会社名'),
                          modelValue: washMark.value.companyName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((washMark.value.companyName) = $event)),
                          style: {"width":"250px","height":"56px"},
                          type: "textarea",
                          maxlength: "30",
                          class: "selectInput1"
                        }, null, 8, ["placeholder", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (!editStatus.value.companyAddress)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "placeholder",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (changeEditStatus('companyAddress')), ["stop"]))
                        }, [
                          _createTextVNode(_toDisplayString(washMark.value.companyAddress
                      ? washMark.value.companyAddress
                      : _unref(t)("请填写会社地址")) + " ", 1),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true),
                    (editStatus.value.companyAddress)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          type: "textarea",
                          rows: 2,
                          placeholder: _unref(t)('请填写会社地址'),
                          modelValue: washMark.value.companyAddress,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((washMark.value.companyAddress) = $event)),
                          style: {"width":"250px","height":"56px","z-index":"100"},
                          maxlength: "50",
                          class: "selectInput2"
                        }, null, 8, ["placeholder", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_unref(isD2C)() && _unref(isJA)())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "MADE IN CHINA"))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_unref(isKO)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([{ 'active': isRotate.value }, 'wash-left ko'])
              }, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ 'active': isRotate.value }, 'text'])
                  }, _toDisplayString(_unref(t)("对折")), 3)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  (!editStatus.value.skuType)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "placeholder abs",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (changeEditStatus('skuType')), ["stop"]))
                      }, [
                        _createTextVNode(_toDisplayString(skuType.value == 1
                  ? _unref(t)("不使用客户商品sku")
                  : skuType.value == 2
                    ? _unref(t)("使用客户商品sku")
                    : skuType.value == 3
                      ? _unref(t)("使用客户商品sku")
                      : _unref(t)("关联商品库填写")) + " ", 1),
                        _hoisted_39
                      ]))
                    : _createCommentVNode("", true),
                  (editStatus.value.skuType)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: skuType.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((skuType).value = $event)),
                        style: {"width":"140px"},
                        class: "selectSku"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _unref(t)('不使用客户商品sku'),
                            value: 1
                          }, null, 8, ["label"]),
                          (_unref(isD2C)())
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 0,
                                label: _unref(t)('使用客户商品sku'),
                                value: 2
                              }, null, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (!_unref(isD2C)())
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                label: _unref(t)('使用客户商品sku'),
                                value: 3
                              }, null, 8, ["label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('商品的规格，请从选项设定画面进行编辑。未输入的情况下不显示')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        color: "#999",
                        class: "cursor-pt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_43,
                  _createElementVNode("span", _hoisted_44, " (" + _toDisplayString(_unref(t)("示例")) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('QUA：')), 1),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('材质为自动读取，不可编辑')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, {
                        color: "#999",
                        class: "cursor-pt"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, " (" + _toDisplayString(_unref(t)("示例")) + ") ", 1)
                ]),
                _hoisted_50,
                _hoisted_51
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(t)("注意")) + "：", 1),
            (!_unref(isKO)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(t)('图片格式支持jpg，png。')), 1),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)('LOGO图片比例为1:1，在水洗标打印时转变为黑白色')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_57, "워싱라벨에 대해 확인 못하시면 고객 센터에게 문의하세요!")),
            (!_unref(isJA)())
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 2,
                  class: "icon-rotate",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (isRotate.value = !isRotate.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(RefreshRight))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(t)("缝制样式")) + "：", 1),
            _hoisted_59
          ])
        ], 2),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            (!_unref(isD2C)())
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: washMark.value.isDefault,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((washMark.value.isDefault) = $event)),
                    disabled: __props.first,
                    "true-label": 1,
                    "false-label": 0
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('设为默认水洗标')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(t)('在下单时，如未主动选择水洗标，将全部设为默认水洗标')), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_63
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: _withModifiers(cancel, ["stop"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("取消")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _withModifiers(save, ["stop"]),
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("保存")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ])
      ]),
      _createVNode(CropperImage, {
        ref: (_value, _refs) => {
          _refs['cropperImage'] = _value
          cropperImage.value = _value
        },
        onSubmit: submitCropperImage,
        imageRatio: imageRatio.value
      }, null, 8, ["imageRatio"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})